export const shouldForwardPropFilter = (keys: (string | number | symbol)[]) => {
  return (prop: any, defaultCB: any) => !(keys).includes(prop) || defaultCB(prop);
  // TODO: Replace any with styled-components properties
  // Or just get rid of it.
};
